import { render, staticRenderFns } from "./NewUserPage.vue?vue&type=template&id=13da3274&"
import script from "./NewUserPage.vue?vue&type=script&lang=ts&"
export * from "./NewUserPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13da3274')) {
      api.createRecord('13da3274', component.options)
    } else {
      api.reload('13da3274', component.options)
    }
    module.hot.accept("./NewUserPage.vue?vue&type=template&id=13da3274&", function () {
      api.rerender('13da3274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/NewUserPage.vue"
export default component.exports